
import { Navigate } from 'react-router-dom';
import { getLocalValue, LoacalVariables } from './commonFunctions/CommonFunctions';

interface ProtectedRouteProps {
    children: React.ReactNode;
    token: string | null
    allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    token,
    allowedRoles = []
}) => {
    const userType = getLocalValue(LoacalVariables.UserType);

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    // If specific roles are required, check if user has one of them
    if (allowedRoles.length > 0 && !allowedRoles.includes(userType)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;